import axios from "../http";
const BASE_URL = process.env.VUE_APP_GENERAL_URL;

/**
 * 总控-区域经理下拉搜索列表
 * @param {*} params
 * @returns
 */
export function postRegionalManagerSelectList(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/regional/manager/select/list`,
    data: params,
  });
}

/**
 * 总控-城市仓保证金审批-20250529
 * @param {*} params
 * @returns
 */
export function postLogisticsEarnestMoneyAudit(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/logistics/earnest_money/audit`,
    data: params,
  });
}

/**
 * 总控-变更城市仓银行卡-20250529
 * @param {*} params
 * @returns
 */
export function postUpdateLogisticsBank(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/update/logistics/bank`,
    data: params,
  });
}
/**
 * 总控-变更城市仓银行卡-20250529
 * @param {*} params
 * @returns
 */
export function certifydetails(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/certify/details`,
    data: params,
  });
}
/**
 * 总控-变更城市仓银行卡-20250529
 * @param {*} params
 * @returns
 */
export function certifylogistics(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/certify/logistics`,
    data: params,
  });
}

/**
 * 总控-身份证OCR识别-20250529
 * @param {*} params
 * @returns
 */
export function postGetIdcardInfo(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/get/idcard/info`,
    data: params,
  });
}

/**
 * 总控-地域单层级列表-20250529
 * @param {*} params
 * @returns
 */
export function postAreaChildList(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/area/child/list`,
    data: params,
  });
}

/**
 * 总控-城市仓持卡人管理列表-20250529
 * @param {*} params
 * @returns
 */
export function postLogisticsBankApplyList(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/logistics/bank/apply/list`,
    data: params,
  });
}

/**
 * 总控-银行卡变更审批-20250529
 * @param {*} params
 * @returns
 */
export function postLogisticsBankApplyAudit(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/logistics/bank/apply/audit`,
    data: params,
  });
}

/**
 * 【城市仓】-持卡人列表导出
 * @param {*} params
 * @returns
 */
export function postLogisticsBankApplyExport(params = {}) {
  return axios({
    responseType: "blob",
    method: "POST",
    url: `${BASE_URL}/logistics/bank/apply/export`,
    data: params,
  });
}

/**
 * 【城市仓】-区域经理列表
 * @param {*} params
 * @returns
 */
export function postRegionalManageList(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/regional/manage/list`,
    data: params,
  });
}

/**
 * 【城市仓】-保存区域经理
 * @param {*} params
 * @returns
 */
export function postRegionalmanageSave(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/regional/manage/save`,
    data: params,
  });
}

/**
 * 【城市仓】-地域三级列表-20250529
 * @param {*} params
 * @returns
 */
export function postAreaTree(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/area/tree`,
    data: params,
  });
}
